import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const toasts = ref([])
  let nextId = 0

  // Add a new toast
  const addToast = (options) => {
    const toast = {
      id: nextId++,
      message: options.message || '',
      type: options.type || 'info', // 'success', 'error', 'warning', 'info'
      duration: options.duration || 5000,
      action: options.action || null,
      persistent: options.persistent || false,
      timestamp: Date.now()
    }

    toasts.value.push(toast)

    // Auto-remove toast after duration (unless persistent)
    if (!toast.persistent && toast.duration > 0) {
      setTimeout(() => {
        removeToast(toast.id)
      }, toast.duration)
    }

    return toast.id
  }

  // Remove a toast by ID
  const removeToast = (id) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  // Clear all toasts
  const clearToasts = () => {
    toasts.value = []
  }

  // Convenience methods for different toast types
  const success = (message, options = {}) => {
    return addToast({ ...options, message, type: 'success' })
  }

  const error = (message, options = {}) => {
    return addToast({ ...options, message, type: 'error' })
  }

  const warning = (message, options = {}) => {
    return addToast({ ...options, message, type: 'warning' })
  }

  const info = (message, options = {}) => {
    return addToast({ ...options, message, type: 'info' })
  }

  return {
    toasts,
    addToast,
    removeToast,
    clearToasts,
    success,
    error,
    warning,
    info
  }
})